import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Table, Button, Space, Row } from 'antd';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEcole } from '../ecole/ecole.reducer';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { getSession } from 'app/shared/reducers/authentication';
import { getClasses, getClassesProf } from '../classe/classe.reducer';
import { getAnneeScolaire } from '../annee-scolaire/annee-scolaire.reducer';
export const ClasseList = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getSession());
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getAnneeScolaire(props.match.params.anneeScolaireId));
    dispatch(getClasses(props.match.params.ecoleid));
  }, []);
  const classeList = useAppSelector(state => state.classe.entities);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const currentAnneeScolaire = useAppSelector(state => state.anneeScolaire.entity);

  const columns = [
    {
      title: 'CLASSES',
      dataIndex: 'classe',
      key: 'classe',
    },
    {
      title: 'CYCLE',
      dataIndex: 'cycle',
      key: 'cycle',
      render: value => value || '-',
    },
    {
      dataIndex: 'id',
      key: 'id',
      render: id => (
        <div>
          <Row className="justify-content-end">
            <Button type="primary" style={{ height: 'auto', width: 'auto' }}>
              <Link
                to={`/calendar/${currentEcole && currentEcole.id}/${currentAnneeScolaire && currentAnneeScolaire.id}/${id}/calendarEntry`}
                id="jh-create-entity"
                data-cy="entityCreateButton"
              >
                <FontAwesomeIcon icon="eye" />
                &nbsp;
              </Link>
            </Button>
            &nbsp;
          </Row>
        </div>
      ),
    },
  ];

  const data = classeList.map((classe, i) => ({
    classe: classe.nom,
    cycle: classe.cycleNom,
    id: classe.id,
  }));

  return (
    <div>
      <h2 id="classe-heading" data-cy="ClasseHeading">
        Classes
      </h2>
      <div className="table-responsive">
        <Table columns={columns} dataSource={data} />
      </div>
    </div>
  );
};

export default ClasseList;
